import React, { useEffect, useState } from 'react';
import { estaUsandoCopia, fechaDeCopia } from '../services/sinConexion';

// Aviso arriba cuando no hay internet: Kontrol muestra la información que
// guardó la última vez que tuvo señal. Desaparece solo cuando vuelve.
function textoFecha(f) {
  if (!f) return '';
  const hoy = new Date().toDateString() === f.toDateString();
  const hora = f.toLocaleTimeString('es-HN', { hour: 'numeric', minute: '2-digit' });
  return hoy ? `de hoy a las ${hora}` : `del ${f.toLocaleDateString('es-HN', { day: 'numeric', month: 'short' })}, ${hora}`;
}

export default function AvisoSinConexion() {
  const [sinRed, setSinRed] = useState(() => !navigator.onLine || estaUsandoCopia());
  useEffect(() => {
    const revisar = () => setSinRed(!navigator.onLine || estaUsandoCopia());
    window.addEventListener('online', revisar);
    window.addEventListener('offline', revisar);
    window.addEventListener('kontrol-conexion', revisar);
    return () => {
      window.removeEventListener('online', revisar);
      window.removeEventListener('offline', revisar);
      window.removeEventListener('kontrol-conexion', revisar);
    };
  }, []);
  if (!sinRed) return null;
  const fecha = textoFecha(fechaDeCopia());
  return (
    <div role="status" style={{ background: '#FEF3C7', border: '1px solid #FCD34D', color: '#78350F', borderRadius: '12px', padding: '10px 14px', marginBottom: '14px', fontSize: '14px', lineHeight: 1.5 }}>
      <b>📴 Sin internet.</b> Estás viendo tu información guardada{fecha ? ` ${fecha}` : ''}.
      {' '}Para vender o hacer cambios necesitas conexión.
    </div>
  );
}
